
import React from 'react'
import OtpInput from '../OtpInput/OtpInput'
import { AlertWrapper } from '../UI/styledConstants'
import { isEmpty } from '../../utils/common'

function AepsOtpScreen({setOtp,otp,seconds,message,setMessage,verifyOtp,resendOtp=() =>{}}) {
	return(
		<div className="tab-content-left">
					<h2>VERIFY OTP</h2>

					<OtpInput type="text" setOtp={setOtp} otp={otp} isDisable={false} placeholder="*" />

					<div className="forgot-password-link" style={{ margin: '6px 0px', textAlign: 'end' }}>
						{seconds > 0 ? (
							<button className="none" style={{ color: '#00baf2', cursor: 'pointer' }}>
								Resend after :{seconds}
							</button>
						) : (
							<button className="none " style={{ color: 'green', cursor: 'pointer' }} onClick={resendOtp}>
								Resend OTP
							</button>
						)}
					</div>
					{!isEmpty(message) && message.place === 'form' && (
						<AlertWrapper className={message.type}>
							<span className="close" onClick={() => setMessage({})}>
								×
							</span>
							{message.msg}
						</AlertWrapper>
					)}
					<button type="submit" className="button-outline" onClick={verifyOtp}>
						VERIFY OTP
					</button>
				</div>
	)
}

export default AepsOtpScreen